import { getAvailablePrescreens_getAvailablePrescreens as AvailablePrescreen } from '@generated/types';

import { SelectOption } from '../_components/forms/SelectDropdown';

export interface PrescreenOption extends SelectOption {
  hirevuePositionId: string;
  linkedJobId?: string;
}

export const toPrescreenOption = (prescreen: AvailablePrescreen): PrescreenOption => {
  if (!prescreen.linked_job_id) {
    return {
      label: `TalentHub - ${prescreen.job_title ?? ''}`,
      value: prescreen.id,
      hirevuePositionId: prescreen.hirevue_position_id,
    };
  }

  return {
    label: `${prescreen.client?.name ?? ''} - ${prescreen.alternate_title ?? prescreen.job_title ?? ''}`,
    value: prescreen.id,
    hirevuePositionId: prescreen.hirevue_position_id,
    linkedJobId: prescreen.linked_job_id,
  };
};
